import './StandardSingleLineTextEntry.css';
import React from 'react';

const errorBorderStyle = {
  border: '3px solid red',
  borderRadius: '6px',
  verticalAlign: 'middle',
  marginTop: '4px',
  fontSize: '18px',
  color: '#666666',
};

const normalBorderStyle = {
  border: '1px solid #ccc',
  verticalAlign: 'middle',
  marginTop: '4px',
  fontSize: '18px',
  color: '#666666',
};

export function StandardSingleLineTextEntry({
  title,
  data,
  setData,
  maxCharacters = 100, // Default maxCharacters
  setCharacterCount = () => {}, // No-op function to avoid errors
  characterCount = 0,
  onError = false,
  onErrorSet = () => {},
  errorText = '',
  errorTextSet = () => {},
  displayCounter = false,
  nullAllowed = true,
}) {
  const handleValueChange = (event) => {
    const value = event.target.value;
    const charCount = value.length;

    // Update character count
    setCharacterCount(charCount);

    if (charCount > maxCharacters) {
      onErrorSet(true);
      errorTextSet(`${title} must be ${maxCharacters} characters or less`);
    } else if (!value && !nullAllowed) {
      onErrorSet(true);
      errorTextSet(`${title} cannot be blank`);
    } else {
      onErrorSet(false);
      errorTextSet('');
    }

    // Update field value
    setData(value);
  };

  return (
    <div className="slteFormRow">
      <div className="slteTitleDiv">
        <label className="slteTitleLabel">{title}</label>
      </div>
      <div className="slteInputDiv">
        <input
          style={onError ? errorBorderStyle : normalBorderStyle}
          className="slteSingleTextInput"
          type="text"
          value={data}
          onChange={handleValueChange}
        />
        {displayCounter && (
          <label className="slteCounterLabel">
            {characterCount}/{maxCharacters}
          </label>
        )}
        <label className="slteErrorLabel">{errorText}</label>
      </div>
    </div>
  );
}
